import React from "react";
import { TableCrypto } from "./TableCrypto";
import { TableGameCurrency } from "./TableGameCurrency";
import { TableOption } from "./TableOption";
import { useApp } from "../../../contexts";
import { CURRENCY_CODES } from "../../../utils/Currency";

export const TabWallet = ({ data }) => {
  const { convertToLocalCurrency, currency } = useApp();
  const convertData = (items) => {
    return (items || []).map((item) => {
      return {
        ...item,
        coin: item.currency_code,
        amount: item.dog_food,
        marketPrice: convertToLocalCurrency(item.currency_rate, CURRENCY_CODES.USD, currency),
        local: convertToLocalCurrency(item.balance, CURRENCY_CODES.USD, currency),
      };
    });
  };

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] xls:gap-[60px] mt-[10px] lg:mt-[24px] xls:mt-[44px]">
      <TableCrypto data={convertData(data?.cryptos ?? [])} />
      <TableGameCurrency data={convertData(data?.games ?? [])} />
      <TableOption data={convertData(data?.options ?? [])} />
    </div>
  );
};
